import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'src/component/ds/ui/tooltip';

interface DeviceNavTooltipProps {
  label: string;
  /** Only open when the trigger's text span is cut off by its ellipsis. */
  whenTruncated?: boolean;
  children: React.ReactElement;
}

/* A sidebar row's tooltip. DeviceNav provides the TooltipProvider. */
export default function DeviceNavTooltip ({ label, whenTruncated = false, children }: DeviceNavTooltipProps) {
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);

  const handleOpenChange = (next: boolean) => {
    if (next && whenTruncated) {
      const text = triggerRef.current?.querySelector('span');
      if (!text || text.scrollWidth <= text.clientWidth) {
        return;
      }
    }
    setOpen(next);
  };

  return (
    <Tooltip open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger ref={triggerRef} asChild>{children}</TooltipTrigger>
      <TooltipContent side='right'>{label}</TooltipContent>
    </Tooltip>
  );
}
